import MentionsOfficialAccountCommentCard from './MentionsOfficialAccountCommentCard';

export default MentionsOfficialAccountCommentCard;
